// Quick add buttons under the cart items (snippets/cart-item-pairings.liquid).
// Bound once on the document: the cart is re-rendered after each change.
if (!window.cartPairings) {
  window.cartPairings = true;

  // Price of the variant picked in the dropdown.
  document.addEventListener('change', (event) => {
    const select = event.target.closest('select[data-cart-pairing-variant]');
    if (!select) return;
    const price = select.closest('[data-cart-pairing]').querySelector('[data-cart-pairing-price]');
    if (price) price.textContent = select.selectedOptions[0].dataset.price;
  });

  // Add to cart, then let the theme re-render the cart sections (same flow as the product form).
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cart-pairing-add]');
    if (!button || button.getAttribute('aria-disabled') === 'true') return;
    event.preventDefault();

    const sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
    );
    const body = new FormData();
    body.append('id', button.closest('[data-cart-pairing]').querySelector('[data-cart-pairing-variant]').value);
    body.append('quantity', 1);
    body.append('sections', sections);
    body.append('sections_url', window.location.pathname);

    const config = FoxTheme.utils.fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = body;

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('btn--loading');
    try {
      const state = await (await fetch(FoxTheme.routes.cart_add_url, config)).json();
      if (state.status) {
        alert(state.description || state.message);
        return;
      }
      const cart = await (
        await fetch(FoxTheme.routes.cart_url, { ...FoxTheme.utils.fetchConfig('json', 'GET') })
      ).json();
      cart.sections = state.sections;
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart });
    } catch (error) {
      console.error(error);
    } finally {
      button.classList.remove('btn--loading');
      button.removeAttribute('aria-disabled');
    }
  });
}
